import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const STORAGE_KEY = 'xl_language';

const RTL_LANGUAGES = ['ar'];

function applyDirection(lng: string) {
  if (RTL_LANGUAGES.includes(lng)) {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = lng;
  } else {
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = lng;
  }
}

const savedLang = localStorage.getItem(STORAGE_KEY) || 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: savedLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

// Apply direction on init
applyDirection(savedLang);

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
  applyDirection(lng);
});

export default i18n;